module.exports = __webpack_public_path__ + "assets/img/img258.2ede6156.png";